// Generated by ReScript, PLEASE EDIT WITH CARE

import * as N_RnrConfig from "../store/N_RnrConfig.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(rewardType) {
  switch (rewardType) {
    case "LOGIN_HOURS" :
        return /* LoginHours */1;
    case "ORDER_FULFILLMENT" :
        return /* OrderFulfillment */2;
    case "ORDER_RATING" :
        return /* OrderRating */0;
    default:
      return ErrorUtils$Catalyst.raiseError(N_RnrConfig.reward_type_em_error_path, N_RnrConfig.reward_type_em_error_message, "");
  }
}

export {
  fromString ,
  
}
/* N_RnrConfig Not a pure module */
